import type {SlotGameStore} from "@gamzix/slot_core";

class BackgroundComponent extends Game.src.component.BaseComponent {
    protected backgroundBonusContainer;
    protected backgroundContainer;

    override onGameReady() {
        super.onGameReady();
        this.backgroundBonusContainer = game.tree.findByName('background_bonus_container');
        this.backgroundContainer = game.tree.findByName('background_container');
    }

    setBonusGameBG() {
        this.backgroundBonusContainer.options.visible = true;
        this.backgroundContainer.options.visible = false;

        //@ts-ignore
        this.view.forceViewUpdate();
    }

    setMainGameBG() {
        if(this.store.gameData.freeSpinsGame.isPlaying() && !(this.store.gameData.bonusGame.win >= this.store.gameData.bet * 5000)){
            return;
        }

        this.backgroundBonusContainer.options.visible = false;
        this.backgroundContainer.options.visible = true;

        //@ts-ignore
        this.view.forceViewUpdate();
    }

    get store(): SlotGameStore{
        return <SlotGameStore>game.store
    }
}

//@ts-ignore
Game.src.component.BackgroundComponent = BackgroundComponent;

